import Vue from 'vue'
import VueI18n, {LocaleMessages} from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages(): LocaleMessages {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages: LocaleMessages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

function lang(): string{
    let language = window.navigator.language.substring(0, 2) || process.env.VUE_APP_I18N_LOCALE || 'nl';
    language = language.toLowerCase()
    if (language !== "fr" && language !== "nl"){
        language = "nl"
    }
    return language
}

export default new VueI18n({
    locale: lang(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'nl',
    messages: loadLocaleMessages()
})
